module.exports = __webpack_public_path__ + "img/furry_ghost_hotel.845c0abe.png";